import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function HelpFaqsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-100 py-4">
        

        

        {/* Page Title */}
        <section className="py-8 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-4xl font-bold text-gray-900">Frequently Asked Questions</h2>
          </div>
        </section>

        {/* Introduction Section */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-base text-gray-700 mb-6 leading-relaxed">
                  At AgriWorks, we know that investing in the right tractor attachments, skid steer grapples, and hydraulic tree shears can make a huge difference in productivity and safety. To help you choose the best equipment for your needs, we've answered the most common questions about our HyReach® Clipper, Teleclipper™, Add-A-Grapple, Grapple Rakes, and other AgriWorks-built tools.
                </p>
                <p className="text-base text-gray-700 leading-relaxed">
                  Whether you're a farmer, contractor, landowner, or municipality, this FAQ guide covers product specs, maintenance, customization options, and support. If you don't see your question here, our team is happy to help — contact us at <a href="tel:6812968160" className="text-[#c41e3a] font-bold hover:underline">(681) 296-8160</a> or through our online form.
                </p>
              </div>
              <div>
                <img 
                                  src="images/525_02.jpg" 
                  alt="Equipment" 
                  className="w-100 rounded-lg shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* General Questions */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold mb-8 text-gray-900">General Questions</h2>
            
            <div className="space-y-4 max-w-4xl">
              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Who is AgriWorks?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> AgriWorks, based in Somerset, New Jersey, designs and builds heavy-duty attachments for tractors, skid steers, telehandlers, and excavators. Since 1992, we've specialized in tree shears, grapples, and hydraulic tools built for landowners, farmers, contractors, and municipalities.</p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Where are your products made?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> All AgriWorks products are proudly designed, engineered, and manufactured in the USA.</p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Do you sell directly to customers?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Yes, we sell through our dealer network and can also work directly with customers. Contact us or find your nearest dealer here.</p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Do you offer custom sizes or modifications?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Yes. Many of our grapples and attachments can be customized to fit your specific bucket or loader. Small fees may apply for custom fabrication.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* HyReach Clipper */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold mb-8 text-gray-900">HyReach® Clipper</h2>
            
            <div className="space-y-4 max-w-4xl">
              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: How big of a tree can the HyReach® Clipper cut?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Depending on the model, the HyReach Clipper can cut trees up to 9 inches in diameter.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What hydraulic pressure is required?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> The Clipper requires a minimum of 2,500 PSI to operate effectively.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What if my tractor or skid steer only has one hydraulic outlet?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> If you're running a Clipper with a rotating head, you'll need a selector valve (manual or electric) to divert flow between the cutting cylinder and rotation cylinder. We offer Xtra Valve Kits for compact tractors (15 gpm) and heavy-duty machines (24 gpm).</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Do I need to sharpen the blade?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> No. The blade has a heavy-duty 1/8″ edge designed to withstand rocks and dirt without dulling. Sharpening may damage the steel. Our blades are built from T1 steel, which resists damage even in rocky or dirt conditions.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Can it cut close to the ground?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Yes. By tilting the Clipper forward and sliding it under the tree, you can make ground-level cuts safely.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What kind of maintenance does it require?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Tighten bolts and grease all zerks before each use. Routine inspections and lubrication will extend the life of your attachment.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Is it safe to control tree fall direction?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Yes. Cutting limbs on the operator's side and tilting the clipper forward helps ensure trees fall away from the cab.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Can I pile brush with the Clipper?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> No. The <strong>HyReach® Clipper</strong> is a cutting tool only and not designed for lifting or piling brush. Using it this way may cause permanent damage.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Can the Clipper be used with equipment other than tractors and skid steers?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Yes. The Clipper can be adapted for backhoes, excavators, telehandlers, and even bucket trucks — as long as the equipment has hydraulic capability.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: How high can the HyReach® Clipper reach?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> The Clipper extends approximately 6 feet beyond the loader's maximum height. For example, if your loader reaches 12 feet, your total reach is about 18 feet.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: How many trees can the Clipper cut per hour?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Cutting speed depends on hydraulic flow and tree size. On average, the Clipper cuts an 8" tree in about 3 seconds, with some operators reporting up to 300 trees per hour.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TeleClipper */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold mb-8 text-gray-900">TeleClipper™</h2>
            
            <div className="space-y-4 max-w-4xl">
              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What is the maximum reach of the TeleClipper?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> The TeleClipper extends up to 10′ 3″ and retracts to 7′ 3″—perfect for clearing fence lines, waterways, and ditches.</p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: How is it operated?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> You can control the TeleClipper from inside your cab with a wireless remote. Some machines allow wired control using 14-pin or 8-pin connectors.</p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What is the best use for the TeleClipper?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> It's ideal for trimming fence rows, managing waterways, and reaching high branches while minimizing damage to your machine or property.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Grapples & Rakes */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold mb-8 text-gray-900">Grapples & Rakes</h2>
            
            <div className="space-y-4 max-w-4xl">
              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What is the Add-A-Grapple?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> The Add-A-Grapple converts standard buckets into full grapples, giving you greater versatility without buying a separate grapple bucket.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Are hoses included with Add-A-Grapple models?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Yes, hoses are included with Contractor and Commercial models. Other models may include hoses or offer them as accessories.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: How much do Add-A-Grapples weigh?</h3>
                  <div className="text-gray-700">
                    <p className="mb-2"><span className="font-semibold">A:</span></p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>Single Add-A-Grapple: ~142 lbs.</li>
                      <li>Double Add-A-Grapple: ~220 lbs.</li>
                      <li>Contractor: ~387 lbs.</li>
                      <li>Commercial: ~413 lbs.</li>
                    </ul>
                    <p className="mt-2">Tip: Choose a grapple that weighs less than 50% of your machine's lift capacity for best performance.</p>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What is the grapple opening size?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Openings range from 35″ to 49″, depending on the model.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What can I pick up with a grapple rake?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Loose material such as brush, logs, rocks, and debris. Grapple rakes are not designed for digging.</p>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Should I choose a single or double grapple?</h3>
                  <div className="text-gray-700">
                    <p className="mb-2"><span className="font-semibold">A:</span></p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li><strong>Single Grapple</strong>: Better for consistent loads like hay or logs.</li>
                      <li><strong>Double Grapple</strong>: Offers more control for uneven or irregular loads.</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What are the specs of the Big Mouth 327 Grapple?</h3>
                  <div className="text-gray-700">
                    <p className="mb-2"><span className="font-semibold">A:</span></p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>Designed for 40–70 hp tractors</li>
                      <li>Available in 63″ or 72″ widths</li>
                      <li>Weighs 438–526 lbs. (depending on brackets)</li>
                      <li>Reinforced tines with 7–10″ spacing</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Technical & Support */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold mb-8 text-gray-900">Technical & Support</h2>
            
            <div className="space-y-4 max-w-4xl">
              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: How do I choose the right attachment for my tractor or skid steer?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Use our product selector guides or call us at <a href="tel:6812968160" className="text-[#c41e3a] font-bold hover:underline">(681) 296-8160</a> for expert recommendations based on your machine's specs and workload.</p>
                </div>
              </div>

              

              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Do you offer replacement parts?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Yes, we provide replacement parts and accessories for all AgriWorks attachments. Contact your dealer or our support team for details.</p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: What warranty do your products come with?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> Most products include a 1-year limited warranty. Check your product manual for details.</p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-sm">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-gray-900">Q: Who do I contact for service or support?</h3>
                  <p className="text-gray-700"><span className="font-semibold">A:</span> You can call our support team at <a href="tel:6812968160" className="text-[#c41e3a] font-bold hover:underline">(681) 296-8160</a> or fill out our contact form.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FEMA Badge & Disclaimer */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4 text-center">
            
            <h2 className="text-2xl font-bold mb-4 text-gray-900">SOLVING TREE & BRUSH PROBLEMS SINCE 1992!</h2>
            <div className="w-24 h-1 bg-[#c41e3a] mx-auto mb-6"></div>
            <p className="text-sm text-gray-600 max-w-3xl mx-auto">
              All products have been carefully manufactured and tested. Should our product prove defective, or appear to be, please discontinue use immediately and contact us. Not responsible for any damage or claims beyond the selling price of the product. No returns allowed without express written consent of company.
            </p>
          </div>
        </section>

        {/* Footer */}
        <footer 
          className="bg-cover bg-center relative py-16"
                  style={{ backgroundImage: 'url(/images/scaled.jpg)'}}
        >
          <div className="absolute inset-0 bg-[#1a1a1a]/90"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-white">
              <div>
                <img 
                                  src="/images/lagoos.png" 
                  alt="AgriWorks Logo" 
                  className="h-24 mb-4"
                />
                <h6 className="text-sm mb-4">
                  Powered by AgriWorks<br />
                 
                  <a href="tel:6812968160" className="hover:underline">(681) 296-8160</a>
                </h6>
                
                
              </div>

              <div>
                <h3 className="font-bold mb-4 text-lg">Contact</h3>
                <ul className="space-y-2 text-sm">
                  <li>
                    <a href="mailto:jolyn.consult@hotmail.com" className="hover:underline">Email: jolyn.consult@hotmail.com</a>
                  </li>
                  <li>
                    <a href="tel:6812968160" className="hover:underline">Phone: (681) 296-8160</a>
                  </li>
                  <li>23 Margaret Dr, Somerset, NJ 08873</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold mb-4 text-lg">Links</h3>
                <ul className="space-y-2 text-sm">
                  <li>
                    <Link to="/products" className="hover:underline">Products</Link>
                  </li>
                  
                  <li>
                    <Link to="/contact" className="hover:underline">Contact Us</Link>
                  </li>
                  
                </ul>
              </div>

              <div>
                <img 
                                  src="/images/made-in-the-usa.webp" 
                  alt="Made in USA" 
                  className="w-48 mb-4"
                />
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-white/20 text-center text-sm text-white/80">
                          <p>© {new Date().getFullYear()} AgriWorks Manufacturing LLC. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </section>
    </div>
  );
}
